import React, { Component } from "react";
import FriendCard from "./components/FriendCard";
import Nav from "./components/Nav";
import Wrapper from "./components/Wrapper";
import Title from "./components/Title";
import Container from "./components/Container";
import Footer from "./components/Footer";
import Row from "./components/Row";
import Column from "./components/Column";
import friends from "./friends.json";
// import Alert from "./components/Alert";
import "./App.css";

// shuffle friends function
function shuffleFriends(array) {
  for (let i = array.length - 1; i > 0; i--) {
    let j = Math.floor(Math.random() * (i + 1));
    [array[i], array[j]] = [array[j], array[i]];
  }
  return array;
}

class App extends Component {
  // Set this.state
  state = {
    friends,
    currentScore: 0,
    topScore: 0,
    message: "",
    clicked: [],
    shakeit: false
  };

  // when character click
  handleClick = id => {
    if (this.state.clicked.indexOf(id) === -1) {
      this.handleIncrement();
      this.setState({
        clicked: this.state.clicked.concat(id),
        // shakeit: false
        message: "Mmmm Donuts"
      });
    } else {
      this.handleReset();
    }
  };

  // increase score when character click
  handleIncrement = () => {
    const newScore = this.state.currentScore + 1;
    this.setState({
      currentScore: newScore,
      message: ""
    });
    if (newScore >= this.state.topScore) {
      this.setState({ topScore: newScore });
    } else if (newScore === 12) {
      this.setState({ message: "You win!" });
    }
    this.handleShuffle();
  };

  // restart game when wrong click
  handleReset = () => {
    this.setState({
      currentScore: 0,
      topScore: this.state.topScore,
      message: "D'oh!",
      clicked: [],
      shakeit: true
    });
    this.handleShuffle();
  };

  // shuffle friends
  handleShuffle = () => {
    let shuffledFriends = shuffleFriends(friends);
    this.setState({ friends: shuffledFriends });
  };

  render() {
    return (
      <Wrapper shakeWrapper={this.state.shakeit}>
        <Nav
          title="The Simpsons"
          score={this.state.currentScore}
          topScore={this.state.topScore}
          message={this.state.message}
        />

        <Title className="title">
          Win by clicking every character
          <br />
          <br />
          Don't click any character twice or you lose!
        </Title>

        <Container>
          <Row>
            {this.state.friends.map(friend => (
              <Column size="md-3 sm-6">
                <FriendCard
                  key={friend.id}
                  handleClick={this.handleClick}
                  handleIncrement={this.handleIncrement}
                  handleReset={this.handleReset}
                  handleShuffle={this.handleShuffle}
                  id={friend.id}
                  image={friend.image}
                />
              </Column>
            ))}
          </Row>
        </Container>
        <Footer />
      </Wrapper>
    );
  }
}

export default App;
